import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const FuelsAndCombustion = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Fuels and Combustion"
    videos={[
      "https://www.youtube.com/embed/N3tLcIu5hbE",
      "https://www.youtube.com/embed/9RaDMQRfzBs",
      "https://www.youtube.com/embed/wwJG2JVg6qM",
      "https://www.youtube.com/embed/vgf1x6sUwjM"
    ]}
    takeaways={[
      { text: "Mostly can expect numericals related to HCV and LCV." },
      { text: "Bomb calorimeter related problems." },
      { text: "Also learn diagram and working principle of Bomb calorimeter." }
    ]}
    questions={[
      "Describe a suitable method for determining the calorific value of a solid fuel.",
      "A sample of coal containing 75% C, 18% H, and 7% ash is tested in a Bomb calorimeter. The following results were obtained.\n\nWeight of coal burnt = 1.2 g\nWeight of water taken = 1200g\nWater equivalent of Bomb & Calorimeter = 3000g\nRise in temperature = 3.0c\nCooling correction = 0.03c\nFuse wire correction = 10 calories\nAcid correction = 60.0 calories\nLatent heat of condensation of steam = 580 cal/g\n\nCalculate the Higher Calorific Value (HCV) and Lower Calorific Value (LCV)",
      "Elaborate on how the calorific value of a solid fuel is determined by a Bomb calorimeter with a neat diagram. Justify the correction required for the determination of high calorific value (HCV)."
    ]}
    exampleVideos={[]}
  />
);
}

export default FuelsAndCombustion;
